<template>
  <div class="template">
    <div class="container-wrapper">
      <div class="container">
        <div
          v-for="item in SCREEN_TEMPLATE_LIST"
          :key="item.templateId"
          class="item">
          <div class="screen-img-wrap">
            <div class="item-img-box">
              <img :src="item.panelThumbnail" alt="">
              <div class="review" @click="handleShowReviewDialog(item)">
                预览
              </div>
            </div>
          </div>
          <div class="item-title">{{ item.panelName }}</div>
        </div>
      </div>
      <ReviewDialog
        v-if="reviewDialogShow"
        :review-obj="reviewObj"
        @close="handleCloseReviewDialog"
        @deleted="handleTemplateDeleted" />
    </div>
  </div>
</template>

<script>
import ReviewDialog from './dialog/reviewDialog.vue'
import { getTemplateListApi } from './fetch'
import { SCREEN_TEMPLATE_LIST } from '@/utils/defaultTemplateData.js'
export default {
  name: 'Template',
  components: {
    ReviewDialog,
  },
  data () {
    return {
      SCREEN_TEMPLATE_LIST,
      reviewDialogShow: false,
      reviewObj: {},
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      try {
        const res = await getTemplateListApi()
        const rows = Array.isArray(res) ? res : []
        this.SCREEN_TEMPLATE_LIST = rows.map((row) => {
          const raw = row.templateContent
          const parsed = typeof raw === 'string' ? JSON.parse(raw) : (raw || {})
          const apiId = row.id !== undefined && row.id !== null ? row.id : row.templateId
          return {
            ...parsed,
            templateId: apiId,
            screenTemplateId: apiId,
          }
        })
      } catch (e) {
        this.$error(e)
      }
    },
    async handleTemplateDeleted () {
      await this.init()
    },
    handleShowReviewDialog (val) {
      this.reviewObj = val
      this.reviewDialogShow = true
    },
    handleCloseReviewDialog () {
      this.reviewObj = {}
      this.reviewDialogShow = false
    },
  },
}
</script>

<style lang="scss" scoped>
  .template{
    padding-top: 40px;
    overflow: scroll;
    .container-wrapper{
      display: flex;
      justify-content: center;
      height: 0;
    }
    .container{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 1110px;
      .item{
        width: 350px;
        height: 270px;
        margin-right: 30px;
        margin-bottom: 40px;
        transition: all 500ms ease 0s;
        &:hover{
          transform: translateY(-10px);
          transition: all 500ms ease 0s;
          .item-title{
            color: #3269FF;
          }
          .item-img-box>.review{
            display: flex;
          }
        }
        .screen-img-wrap{
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .item-img-box{
          display: inline-block;
          font-size: 0;
          box-shadow: 3px 3px 12px rgba(0,0,0,0.2);
          opacity: 1;
          border-radius: 8px;
          position: relative;
          img{
            max-width: 350px;
            max-height: 200px;
            border-radius: 8px;
          }

          .review{
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            border-radius: 8px;
            display: none;
            align-items: center;
            justify-content: center;
            background-color: rgba(0,0,0,0.5);
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            cursor: pointer
          }
        }
        .item-title{
          margin-top: 10px;
          text-align: center;
          color: #4E4E4E;
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }

</style>
